import React, { useCallback, useEffect, useState } from 'react';
import { Megaphone } from 'lucide-react';
import { ReportModal } from './ReportModal';
import { PhotoRow } from './JobInfo';

export const STATUS_STYLE = {
  open: 'bg-red-100 text-red-800',
  resolved: 'bg-emerald-100 text-emerald-800',
  pending: 'bg-amber-100 text-amber-800',
  approved: 'bg-sky-100 text-sky-800',
  rejected: 'bg-slate-200 text-slate-700',
  reimbursed: 'bg-emerald-100 text-emerald-800',
};
const TYPE_LABEL = { defect: 'Vehicle defect', expense: 'Expense', issue: 'Issue' };

export const DriverReports = ({ authFetch, jobs, onChanged }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    authFetch('get', '/driver/reports').then(({ data }) => setData(data)).catch(() => {});
  }, [authFetch]);
  useEffect(() => { load(); }, [load]);

  return (
    <section className="mb-6 rounded-xl border border-slate-200 bg-white p-5" data-testid="driver-reports">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500">Problems & defects</div>
          <h2 className="font-display text-lg font-extrabold text-[color:var(--mv-navy)]">My reports</h2>
        </div>
        <button type="button" onClick={() => setOpen(true)} className="h-12 px-5 rounded-md bg-[color:var(--mv-orange)] hover:bg-orange-600 text-white font-black inline-flex items-center gap-2" data-testid="driver-report-btn">
          <Megaphone className="w-5 h-5" /> Report
        </button>
      </div>
      {data && data.reports.length === 0 && <div className="mt-3 text-xs text-slate-500" data-testid="driver-reports-empty">No reports yet. Tap Report for a vehicle defect or an issue.</div>}
      {data && data.reports.length > 0 && (
        <div className="mt-3 divide-y divide-slate-100" data-testid="driver-reports-list">
          {data.reports.slice(0, 10).map(r => (
            <div key={r.id} className="py-3" data-testid={`driver-report-${r.ref}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                  <div className="text-sm font-bold text-[color:var(--mv-navy)] truncate">{r.category_label}{r.amount ? ` · £${r.amount.toFixed(2)}` : ''}</div>
                  <div className="text-xs text-slate-500 truncate">{TYPE_LABEL[r.type]} · #{r.ref}{r.van_reg ? ` · ${r.van_reg}` : ''}{r.job_ref ? ` · job #${r.job_ref}` : ''} · {new Date(r.created_at + 'Z').toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })}</div>
                </div>
                <span className={`shrink-0 text-[10px] font-black uppercase px-2 py-0.5 rounded-full ${STATUS_STYLE[r.status]}`} data-testid={`driver-report-status-${r.ref}`}>{r.status}</span>
              </div>
              {r.admin_note && <div className="mt-1 text-xs text-indigo-800 bg-indigo-50 rounded px-2 py-1">Office: {r.admin_note}</div>}
              {r.photos.length > 0 && <div className="mt-2"><PhotoRow photos={r.photos} testid={`driver-report-photos-${r.ref}`} /></div>}
            </div>
          ))}
        </div>
      )}
      {open && data && (
        <ReportModal authFetch={authFetch} jobs={jobs} categories={data.categories} onClose={() => setOpen(false)} onCreated={() => { load(); onChanged?.(); }} />
      )}
    </section>
  );
};
